// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.zone-wizard-page {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 1.5rem clamp(1rem, 2.5vw, 2rem) 2rem;
}

.page-header,
.page-heading,
.panel-heading,
.step-footer,
.table-footer,
.review-section-heading,
.field-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.page-header {
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.page-heading {
  justify-content: flex-start;
  align-items: flex-start;
  min-width: 0;
}

.heading-icon,
.panel-heading-icon {
  display: grid;
  flex: 0 0 auto;
  width: 3rem;
  height: 3rem;
  place-items: center;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.35rem;
}

.eyebrow,
.panel-kicker {
  margin: 0 0 0.25rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.page-header h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  font-weight: 750;
  letter-spacing: -0.035em;
}

.subtitle {
  max-width: 52rem;
  margin: 0.45rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
  line-height: 1.55;
}

.cancel-top {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border-radius: var(--ca-radius-md, 8px);
}

.page-alert {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.page-alert span {
  min-width: 0;
}

.initial-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 10rem;
  color: var(--ca-text-secondary, #4b5870);
}

.wizard-stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.35rem, 1.3vw, 1.2rem);
  margin: 0 auto 1.4rem;
  padding: 1.1rem 1.4rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: 0 3px 12px rgba(18, 35, 68, 0.035);
}

.step-item {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  padding: 0.2rem;
  border: 0;
  background: transparent;
  color: var(--ca-text-muted, #8c96a8);
  cursor: default;
  text-align: left;
}

.step-item:disabled {
  opacity: 1;
}

.step-icon {
  display: grid;
  width: 2.35rem;
  height: 2.35rem;
  flex: 0 0 2.35rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 50%;
  background: var(--ca-bg-secondary, #eef2f8);
  font-size: 1rem;
  transition: all 0.18s ease;
}

.step-label {
  font-size: 0.82rem;
  font-weight: 650;
  white-space: nowrap;
}

.step-item.active {
  color: var(--ca-primary, #0e2e80);
}

.step-item.active .step-icon {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  box-shadow: 0 0 0 4px rgba(40, 80, 173, 0.1);
}

.step-item.completed {
  color: var(--ca-success, #198754);
  cursor: pointer;
}

.step-item.completed .step-icon {
  border-color: var(--ca-success, #198754);
  background: var(--ca-success, #198754);
  color: #fff;
}

.step-connector {
  width: clamp(1rem, 4vw, 4rem);
  height: 2px;
  flex: 0 1 4rem;
  background: var(--ca-border, #dfe4ec);
}

.step-connector.completed {
  background: var(--ca-success, #198754);
}

.wizard-card {
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: 0 5px 20px rgba(18, 35, 68, 0.04);
}

.wizard-panel {
  min-width: 0;
  padding: clamp(1rem, 2.5vw, 1.8rem);
}

.panel-heading {
  align-items: flex-start;
  margin-bottom: 1.4rem;
}

.panel-heading h2 {
  margin: 0.1rem 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.25rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.panel-heading p {
  max-width: 58rem;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.85rem;
  line-height: 1.55;
}

.panel-heading-icon {
  width: 2.65rem;
  height: 2.65rem;
  font-size: 1.2rem;
}

.heading-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.add-resource-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  white-space: nowrap;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.8rem;
}

.zone-form {
  width: 100%;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 1.25rem;
}

.form-field {
  min-width: 0;
  margin-bottom: 1.25rem;
}

.form-field-wide {
  grid-column: 1/-1;
}

.form-field label {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
  font-weight: 700;
}

.required-mark {
  color: var(--ca-danger, #dc3545);
}

.form-control,
.form-select {
  min-width: 0;
  min-height: 2.7rem;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  color: var(--ca-text-primary, #172033);
  font-size: 0.88rem;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.18rem rgba(40, 80, 173, 0.13);
}

.description-control {
  min-height: 6rem;
  resize: vertical;
}

.field-hint {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.field-error {
  color: var(--ca-danger, #dc3545);
  font-size: 0.75rem;
}

.field-meta {
  min-height: 1.25rem;
  margin-top: 0.3rem;
}

.input-with-action {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}

.input-with-action .form-select {
  flex: 1 1 auto;
}

.icon-action {
  display: inline-grid;
  width: 2.7rem;
  min-width: 2.7rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.15rem;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.icon-action:hover {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
}

.inline-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
}

.required-note {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.76rem;
}

.selection-count {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex: 0 0 auto;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(12rem, 1.5fr) minmax(11rem, 0.85fr) auto;
  gap: 0.7rem;
  margin-bottom: 1rem;
}

.search-field {
  display: flex;
  min-width: 0;
}

.search-field .form-control {
  min-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: grid;
  width: 2.7rem;
  flex: 0 0 2.7rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.clear-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  white-space: nowrap;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.table-region app-main-table {
  display: block;
  min-width: 0;
}

.table-footer {
  align-items: center;
  margin-top: 0.9rem;
  padding-top: 0.8rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.76rem;
}

.table-footer app-pagination {
  max-width: 100%;
}

.state-panel,
.empty-state {
  display: flex;
  min-height: 12rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  padding: 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.state-panel > i,
.empty-state > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.8rem;
}

.state-panel h3,
.empty-state h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 700;
}

.state-panel p,
.empty-state p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.loading-spinner {
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: zone-spin 0.8s linear infinite;
}

.loading-spinner.small {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.inline-loading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 3rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.inline-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
  padding: 0.7rem 0.8rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  font-size: 0.82rem;
}

.inline-error button {
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
}

.review-panel {
  max-width: none;
}

.review-section {
  margin-top: 1.1rem;
  padding: 1.1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.review-section-heading {
  margin-bottom: 0.8rem;
}

.review-section-heading h3 {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  font-size: 0.94rem;
  font-weight: 750;
}

.review-section-heading h3 > i {
  color: var(--ca-primary, #0e2e80);
}

.review-count {
  display: inline-grid;
  min-width: 1.45rem;
  height: 1.45rem;
  place-items: center;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.72rem;
}

.review-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem 1.5rem;
  margin: 0;
}

.review-details > div {
  min-width: 0;
}

.review-details .detail-wide {
  grid-column: 1/-1;
}

.review-details dt {
  margin-bottom: 0.25rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.73rem;
  font-weight: 700;
}

.review-details dd {
  margin: 0;
  overflow-wrap: anywhere;
  color: var(--ca-text-primary, #172033);
  font-size: 0.87rem;
  white-space: pre-wrap;
}

.review-details .identifier {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.78rem;
}

.review-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.review-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: 100%;
  padding: 0.5rem 0.7rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
}

.review-chip i {
  color: var(--ca-primary, #0e2e80);
}

.review-chip span {
  overflow-wrap: anywhere;
}

.review-empty {
  margin: 0;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.82rem;
}

.submit-alert {
  margin-top: 1rem;
}

.step-footer {
  margin-top: 1.6rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.step-footer .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.55rem;
  padding: 0.6rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.83rem;
  font-weight: 650;
}

.step-footer .btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
}

.step-footer .btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.step-footer .btn-outline-secondary {
  border-color: var(--ca-border, #dfe4ec);
  color: var(--ca-text-secondary, #4b5870);
}

.finish-button {
  min-width: 11rem;
}

.button-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: zone-spin 0.7s linear infinite;
}

@keyframes zone-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .wizard-stepper {
    justify-content: space-between;
    gap: 0.25rem;
    padding-inline: 0.7rem;
  }
  .step-item {
    flex-direction: column;
    justify-content: center;
    gap: 0.35rem;
    flex: 1 1 0;
    text-align: center;
  }
  .step-label {
    font-size: 0.7rem;
    white-space: normal;
  }
  .step-connector {
    width: 0.7rem;
    flex: 0 0 0.7rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-button {
    justify-self: start;
  }
  .heading-actions {
    align-items: flex-end;
    flex-direction: column;
  }
}
@media (max-width: 620px) {
  .zone-wizard-page {
    padding: 1rem 0.7rem 1.5rem;
  }
  .page-header {
    flex-direction: column;
  }
  .cancel-top {
    align-self: flex-end;
  }
  .heading-icon {
    width: 2.5rem;
    height: 2.5rem;
  }
  .panel-heading {
    gap: 0.6rem;
  }
  .panel-heading-icon {
    display: none;
  }
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .form-field-wide {
    grid-column: auto;
  }
  .heading-actions {
    width: 100%;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .selection-count {
    padding: 0.4rem 0.5rem;
    font-size: 0.7rem;
  }
  .table-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .table-footer app-pagination {
    align-self: flex-end;
  }
  .review-details {
    grid-template-columns: minmax(0, 1fr);
  }
  .review-details .detail-wide {
    grid-column: auto;
  }
  .step-footer {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .step-footer .btn {
    flex: 1 1 auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/zone-management/zone/zone-create-or-update/zone-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,6CAAA;AAFF;;AAKA;;;;;;;EAOE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAKA;EAAe,uBAAA;EAAyB,qBAAA;AAAxC;;AACA;EAAgB,2BAAA;EAA6B,uBAAA;EAAyB,YAAA;AAKtE;;AAJA;;EAEE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AAOF;;AALA;;EAEE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAQF;;AANA;EACE,SAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,wBAAA;AASF;;AAPA;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AAUF;;AARA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uCAAA;AAWF;;AATA;EAAc,aAAA;EAAe,mBAAA;EAAqB,YAAA;AAelD;;AAdA;EAAmB,YAAA;AAkBnB;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,8CAAA;AAoBF;;AAlBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;AAqBF;;AAnBA;EAAsB,UAAA;AAuBtB;;AAtBA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;EACA,0BAAA;AAyBF;;AAvBA;EAAc,kBAAA;EAAmB,gBAAA;EAAkB,mBAAA;AA6BnD;;AA5BA;EAAoB,iCAAA;AAgCpB;;AA/BA;EACE,wCAAA;EACA,sCAAA;EACA,WAAA;EACA,4CAAA;AAkCF;;AAhCA;EAAuB,iCAAA;EAAmC,eAAA;AAqC1D;;AApCA;EAAkC,wCAAA;EAA0C,sCAAA;EAAwC,WAAA;AA0CpH;;AAzCA;EAAkB,6BAAA;EAA+B,WAAA;EAAa,cAAA;EAAgB,qCAAA;AAgD9E;;AA/CA;EAA4B,sCAAA;AAmD5B;;AAjDA;EACE,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,6CAAA;AAoDF;;AAlDA;EAAgB,YAAA;EAAc,mCAAA;AAuD9B;;AAtDA;EAAiB,uBAAA;EAAyB,qBAAA;AA2D1C;;AA1DA;EACE,uBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AA6DF;;AA3DA;EAAmB,gBAAA;EAAkB,SAAA;EAAW,wCAAA;EAA0C,kBAAA;EAAmB,iBAAA;AAmE7G;;AAlEA;EAAsB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AAwEvD;;AAvEA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,eAAA;EAAiB,WAAA;AA+EnG;;AA9EA;EAAuB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,mBAAA;EAAqB,uCAAA;EAAyC,iBAAA;AAuF7I;;AArFA;EAAa,WAAA;AAyFb;;AAxFA;EAAa,aAAA;EAAe,gDAAA;EAAkD,cAAA;AA8F9E;;AA7FA;EAAc,YAAA;EAAc,sBAAA;AAkG5B;;AAjGA;EAAmB,iBAAA;AAqGnB;;AApGA;EAAoB,cAAA;EAAgB,sBAAA;EAAuB,sCAAA;EAAwC,kBAAA;EAAmB,gBAAA;AA4GtH;;AA3GA;EAAiB,gCAAA;AA+GjB;;AA9GA;;EAEE,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,uCAAA;EACA,sCAAA;EACA,kBAAA;AAiHF;;AA/GA;;EACqB,4CAAA;EAA8C,iDAAA;AAoHnE;;AAnHA;EAAuB,gBAAA;EAAkB,gBAAA;AAwHzC;;AAvHA;EAAc,oCAAA;EAAsC,kBAAA;AA4HpD;;AA3HA;EAAe,gCAAA;EAAkC,kBAAA;AAgIjD;;AA/HA;EAAc,mBAAA;EAAqB,kBAAA;AAoInC;;AAnIA;EAAqB,aAAA;EAAe,oBAAA;EAAsB,WAAA;AAyI1D;;AAxIA;EAAkC,cAAA;AA4IlC;;AA3IA;EACE,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,kBAAA;EACA,0DAAA;AA8IF;;AA5IA;EAAqB,wCAAA;EAA0C,6CAAA;AAiJ/D;;AAhJA;EAAe,UAAA;EAAY,SAAA;EAAW,uBAAA;EAAyB,iCAAA;EAAmC,gBAAA;EAAkB,0BAAA;AAyJpH;;AAxJA;EAAiB,oCAAA;EAAsC,kBAAA;AA6JvD;;AA3JA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,iDAAA;EACA,oBAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA8JF;;AA5JA;EAAkB,aAAA;EAAe,sEAAA;EAAuE,WAAA;EAAY,mBAAA;AAmKpH;;AAlKA;EAAgB,aAAA;EAAe,YAAA;AAuK/B;;AAtKA;EAA8B,YAAA;EAAc,0BAAA;EAA4B,6BAAA;AA4KxE;;AA3KA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;AA8KF;;AA5KA;EAAuB,2CAAA;AAgLvB;;AA/KA;EAAgB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAY,mBAAA;AAuLhG;;AAtLA;EAAgB,YAAA;EAAc,gBAAA;AA2L9B;;AA1LA;EAA+B,cAAA;EAAgB,YAAA;AA+L/C;;AA9LA;EAAgB,mBAAA;EAAqB,kBAAA;EAAmB,mBAAA;EAAoB,qDAAA;EAAuD,oCAAA;EAAsC,kBAAA;AAuMzK;;AAtMA;EAA+B,eAAA;AA0M/B;;AAxMA;;EAEE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;AA2MF;;AAzMA;;EACmB,uCAAA;EAAyC,iBAAA;AA8M5D;;AA7MA;;EACkB,SAAA;EAAW,sCAAA;EAAwC,eAAA;EAAiB,gBAAA;AAoNtF;;AAnNA;;EACiB,SAAA;EAAW,wCAAA;EAA0C,kBAAA;AAyNtE;;AAxNA;EAAmB,gCAAA;AA4NnB;;AA3NA;EAAmB,qBAAA;EAAuB,aAAA;EAAe,cAAA;EAAgB,2CAAA;EAA6C,4CAAA;EAA8C,kBAAA;EAAoB,yCAAA;AAqOxL;;AApOA;EAAyB,WAAA;EAAa,YAAA;EAAc,iBAAA;AA0OpD;;AAzOA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAa,gBAAA;EAAkB,wCAAA;EAA0C,kBAAA;AAkP/H;;AAjPA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,gBAAA;EAAiB,sBAAA;EAAsB,2CAAA;EAA6C,uCAAA;EAAyC,wCAAA;EAA0C,kBAAA;AA6PvO;;AA5PA;EAAuB,SAAA;EAAW,uBAAA;EAAyB,iCAAA;EAAmC,gBAAA;EAAkB,0BAAA;AAoQhH;;AAlQA;EAAgB,eAAA;AAsQhB;;AArQA;EAAkB,kBAAA;EAAoB,eAAA;EAAiB,iDAAA;EAAmD,uCAAA;AA4Q1G;;AA3QA;EAA0B,qBAAA;AA+Q1B;;AA9QA;EAA6B,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAa,SAAA;EAAW,kBAAA;EAAmB,gBAAA;AAuR5G;;AAtRA;EAAiC,iCAAA;AA0RjC;;AAzRA;EAAgB,oBAAA;EAAsB,kBAAA;EAAoB,eAAA;EAAiB,mBAAA;EAAqB,kBAAA;EAAmB,oBAAA;EAAsB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;AAqS3N;;AApSA;EAAkB,aAAA;EAAe,gDAAA;EAAkD,kBAAA;EAAmB,SAAA;AA2StG;;AA1SA;EAAwB,YAAA;AA8SxB;;AA7SA;EAA+B,iBAAA;AAiT/B;;AAhTA;EAAqB,sBAAA;EAAuB,oCAAA;EAAsC,kBAAA;EAAmB,gBAAA;AAuTrG;;AAtTA;EAAqB,SAAA;EAAW,uBAAA;EAAyB,sCAAA;EAAwC,kBAAA;EAAmB,qBAAA;AA8TpH;;AA7TA;EAA8B,2DAAA;EAA6D,kBAAA;AAkU3F;;AAjUA;EAAoB,aAAA;EAAe,eAAA;EAAiB,WAAA;AAuUpD;;AAtUA;EAAe,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,eAAA;EAAiB,sBAAA;EAAsB,iDAAA;EAAmD,oBAAA;EAAsB,4CAAA;EAA8C,wCAAA;EAA0C,kBAAA;AAmV/Q;;AAlVA;EAAiB,iCAAA;AAsVjB;;AArVA;EAAoB,uBAAA;AAyVpB;;AAxVA;EAAgB,SAAA;EAAW,oCAAA;EAAsC,kBAAA;AA8VjE;;AA7VA;EAAgB,gBAAA;AAiWhB;;AAhWA;EAAe,kBAAA;EAAoB,iBAAA;EAAmB,qDAAA;AAsWtD;;AArWA;EAAoB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAY,mBAAA;EAAqB,oBAAA;EAAqB,uCAAA;EAAyC,kBAAA;EAAmB,gBAAA;AAiX1M;;AAhXA;EAA4B,wCAAA;EAA0C,sCAAA;AAqXtE;;AApXA;EAAiD,6CAAA;EAA+C,2CAAA;AAyXhG;;AAxXA;EAAsC,uCAAA;EAAyC,wCAAA;AA6X/E;;AA5XA;EAAiB,gBAAA;AAgYjB;;AA/XA;EAAkB,WAAA;EAAa,YAAA;EAAc,2CAAA;EAAyC,sBAAA;EAAwB,kBAAA;EAAoB,yCAAA;AAwYlI;;AAtYA;EAAuB;IAAK,yBAAA;EA2Y1B;AACF;AA3YA;EACE;IAAkB,8BAAA;IAAgC,YAAA;IAAa,sBAAA;EAgZ/D;EA/YA;IAAa,sBAAA;IAAwB,uBAAA;IAAyB,YAAA;IAAa,WAAA;IAAa,kBAAA;EAsZxF;EArZA;IAAc,iBAAA;IAAkB,mBAAA;EAyZhC;EAxZA;IAAkB,aAAA;IAAc,gBAAA;EA4ZhC;EA3ZA;IAAkB,qCAAA;EA8ZlB;EA7ZA;IAAgB,mBAAA;EAgahB;EA/ZA;IAAmB,qBAAA;IAAuB,sBAAA;EAma1C;AACF;AAlaA;EACE;IAAoB,2BAAA;EAqapB;EApaA;IAAe,sBAAA;EAuaf;EAtaA;IAAc,oBAAA;EAyad;EAxaA;IAAgB,aAAA;IAAe,cAAA;EA4a/B;EA3aA;IAAiB,WAAA;EA8ajB;EA7aA;IAAsB,aAAA;EAgbtB;EA/aA;IAAa,qCAAA;EAkbb;EAjbA;IAAmB,iBAAA;EAobnB;EAnbA;IAAmB,WAAA;IAAa,uBAAA;IAAyB,mBAAA;IAAqB,eAAA;EAyb9E;EAxbA;IAAmB,sBAAA;IAAsB,iBAAA;EA4bzC;EA3bA;IAAgB,uBAAA;IAAyB,sBAAA;EA+bzC;EA9bA;IAA+B,oBAAA;EAic/B;EAhcA;IAAkB,qCAAA;EAmclB;EAlcA;IAA+B,iBAAA;EAqc/B;EApcA;IAAe,oBAAA;IAAsB,eAAA;EAwcrC;EAvcA;IAAoB,cAAA;EA0cpB;AACF;AAzcA;EACE;IAAyB,qCAAA;IAAsC,uCAAA;IAAyC,sCAAA;IAAuC,gCAAA;EA+c/I;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.zone-wizard-page {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 1.5rem clamp(1rem, 2.5vw, 2rem) 2rem;\n}\n\n.page-header,\n.page-heading,\n.panel-heading,\n.step-footer,\n.table-footer,\n.review-section-heading,\n.field-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.page-header { align-items: flex-start; margin-bottom: 1.5rem; }\n.page-heading { justify-content: flex-start; align-items: flex-start; min-width: 0; }\n.heading-icon,\n.panel-heading-icon {\n  display: grid;\n  flex: 0 0 auto;\n  width: 3rem;\n  height: 3rem;\n  place-items: center;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.35rem;\n}\n.eyebrow,\n.panel-kicker {\n  margin: 0 0 .25rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: .68rem;\n  font-weight: 800;\n  letter-spacing: .12em;\n  text-transform: uppercase;\n}\n.page-header h1 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2vw, 1.8rem);\n  font-weight: 750;\n  letter-spacing: -.035em;\n}\n.subtitle {\n  max-width: 52rem;\n  margin: .45rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: .88rem;\n  line-height: 1.55;\n}\n.cancel-top {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: .45rem;\n  border-radius: var(--ca-radius-md, 8px);\n}\n.page-alert { display: flex; align-items: center; gap: .55rem; }\n.page-alert span { min-width: 0; }\n.initial-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: .75rem;\n  min-height: 10rem;\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.wizard-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(.35rem, 1.3vw, 1.2rem);\n  margin: 0 auto 1.4rem;\n  padding: 1.1rem 1.4rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: 0 3px 12px rgba(18, 35, 68, .035);\n}\n.step-item {\n  display: inline-flex;\n  align-items: center;\n  gap: .65rem;\n  min-width: 0;\n  padding: .2rem;\n  border: 0;\n  background: transparent;\n  color: var(--ca-text-muted, #8c96a8);\n  cursor: default;\n  text-align: left;\n}\n.step-item:disabled { opacity: 1; }\n.step-icon {\n  display: grid;\n  width: 2.35rem;\n  height: 2.35rem;\n  flex: 0 0 2.35rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 50%;\n  background: var(--ca-bg-secondary, #eef2f8);\n  font-size: 1rem;\n  transition: all .18s ease;\n}\n.step-label { font-size: .82rem; font-weight: 650; white-space: nowrap; }\n.step-item.active { color: var(--ca-primary, #0e2e80); }\n.step-item.active .step-icon {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(40, 80, 173, .1);\n}\n.step-item.completed { color: var(--ca-success, #198754); cursor: pointer; }\n.step-item.completed .step-icon { border-color: var(--ca-success, #198754); background: var(--ca-success, #198754); color: #fff; }\n.step-connector { width: clamp(1rem, 4vw, 4rem); height: 2px; flex: 0 1 4rem; background: var(--ca-border, #dfe4ec); }\n.step-connector.completed { background: var(--ca-success, #198754); }\n\n.wizard-card {\n  overflow: hidden;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: 0 5px 20px rgba(18, 35, 68, .04);\n}\n.wizard-panel { min-width: 0; padding: clamp(1rem, 2.5vw, 1.8rem); }\n.panel-heading { align-items: flex-start; margin-bottom: 1.4rem; }\n.panel-heading h2 {\n  margin: .1rem 0 .3rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.25rem;\n  font-weight: 750;\n  letter-spacing: -.02em;\n}\n.panel-heading p { max-width: 58rem; margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .85rem; line-height: 1.55; }\n.panel-heading-icon { width: 2.65rem; height: 2.65rem; font-size: 1.2rem; }\n.heading-actions { display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: .6rem; }\n.add-resource-button { display: inline-flex; align-items: center; gap: .45rem; white-space: nowrap; border-radius: var(--ca-radius-md, 8px); font-size: .8rem; }\n\n.zone-form { width: 100%; }\n.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 1.25rem; }\n.form-field { min-width: 0; margin-bottom: 1.25rem; }\n.form-field-wide { grid-column: 1 / -1; }\n.form-field label { display: block; margin-bottom: .45rem; color: var(--ca-text-primary, #172033); font-size: .85rem; font-weight: 700; }\n.required-mark { color: var(--ca-danger, #dc3545); }\n.form-control,\n.form-select {\n  min-width: 0;\n  min-height: 2.7rem;\n  border-color: var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  color: var(--ca-text-primary, #172033);\n  font-size: .88rem;\n}\n.form-control:focus,\n.form-select:focus { border-color: var(--ca-input-focus, #2850ad); box-shadow: 0 0 0 .18rem rgba(40, 80, 173, .13); }\n.description-control { min-height: 6rem; resize: vertical; }\n.field-hint { color: var(--ca-text-muted, #8c96a8); font-size: .75rem; }\n.field-error { color: var(--ca-danger, #dc3545); font-size: .75rem; }\n.field-meta { min-height: 1.25rem; margin-top: .3rem; }\n.input-with-action { display: flex; align-items: stretch; gap: .5rem; }\n.input-with-action .form-select { flex: 1 1 auto; }\n.icon-action {\n  display: inline-grid;\n  width: 2.7rem;\n  min-width: 2.7rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.15rem;\n  transition: background .15s ease, border-color .15s ease;\n}\n.icon-action:hover { border-color: var(--ca-primary, #0e2e80); background: var(--ca-surface-active, #eef3ff); }\n.inline-link { padding: 0; border: 0; background: transparent; color: var(--ca-primary, #0e2e80); font-weight: 700; text-decoration: underline; }\n.required-note { color: var(--ca-text-muted, #8c96a8); font-size: .76rem; }\n\n.selection-count {\n  display: inline-flex;\n  align-items: center;\n  gap: .45rem;\n  flex: 0 0 auto;\n  padding: .5rem .75rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 999px;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: .78rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.search-toolbar { display: grid; grid-template-columns: minmax(12rem, 1.5fr) minmax(11rem, .85fr) auto; gap: .7rem; margin-bottom: 1rem; }\n.search-field { display: flex; min-width: 0; }\n.search-field .form-control { min-width: 0; border-top-right-radius: 0; border-bottom-right-radius: 0; }\n.search-submit {\n  display: grid;\n  width: 2.7rem;\n  flex: 0 0 2.7rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n.search-submit:hover { background: var(--ca-primary-dark, #0d2863); }\n.clear-button { display: inline-flex; align-items: center; justify-content: center; gap: .4rem; white-space: nowrap; }\n.table-region { min-width: 0; overflow-x: auto; }\n.table-region app-main-table { display: block; min-width: 0; }\n.table-footer { align-items: center; margin-top: .9rem; padding-top: .8rem; border-top: 1px solid var(--ca-border-light, #e9edf3); color: var(--ca-text-muted, #8c96a8); font-size: .76rem; }\n.table-footer app-pagination { max-width: 100%; }\n\n.state-panel,\n.empty-state {\n  display: flex;\n  min-height: 12rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: .55rem;\n  padding: 1.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n}\n.state-panel > i,\n.empty-state > i { color: var(--ca-primary-light, #2850ad); font-size: 1.8rem; }\n.state-panel h3,\n.empty-state h3 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1rem; font-weight: 700; }\n.state-panel p,\n.empty-state p { margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .84rem; }\n.error-state > i { color: var(--ca-danger, #dc3545); }\n.loading-spinner { display: inline-block; width: 1.8rem; height: 1.8rem; border: 3px solid var(--ca-border, #dfe4ec); border-top-color: var(--ca-primary, #0e2e80); border-radius: 50%; animation: zone-spin .8s linear infinite; }\n.loading-spinner.small { width: 1rem; height: 1rem; border-width: 2px; }\n.inline-loading { display: flex; align-items: center; gap: .55rem; min-height: 3rem; color: var(--ca-text-secondary, #4b5870); font-size: .82rem; }\n.inline-error { display: flex; align-items: center; gap: .5rem; margin: .5rem 0; padding: .7rem .8rem; border: 1px solid var(--ca-danger, #dc3545); border-radius: var(--ca-radius-md, 8px); background: var(--ca-danger-bg, #fdecef); font-size: .82rem; }\n.inline-error button { border: 0; background: transparent; color: var(--ca-primary, #0e2e80); font-weight: 700; text-decoration: underline; }\n\n.review-panel { max-width: none; }\n.review-section { margin-top: 1.1rem; padding: 1.1rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-md, 8px); }\n.review-section-heading { margin-bottom: .8rem; }\n.review-section-heading h3 { display: flex; align-items: center; gap: .55rem; margin: 0; font-size: .94rem; font-weight: 750; }\n.review-section-heading h3 > i { color: var(--ca-primary, #0e2e80); }\n.review-count { display: inline-grid; min-width: 1.45rem; height: 1.45rem; place-items: center; padding: 0 .35rem; border-radius: 999px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: .72rem; }\n.review-details { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .9rem 1.5rem; margin: 0; }\n.review-details > div { min-width: 0; }\n.review-details .detail-wide { grid-column: 1 / -1; }\n.review-details dt { margin-bottom: .25rem; color: var(--ca-text-muted, #8c96a8); font-size: .73rem; font-weight: 700; }\n.review-details dd { margin: 0; overflow-wrap: anywhere; color: var(--ca-text-primary, #172033); font-size: .87rem; white-space: pre-wrap; }\n.review-details .identifier { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: .78rem; }\n.review-chip-list { display: flex; flex-wrap: wrap; gap: .5rem; }\n.review-chip { display: inline-flex; align-items: center; gap: .45rem; max-width: 100%; padding: .5rem .7rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: 999px; background: var(--ca-surface-hover, #f8faff); color: var(--ca-text-secondary, #4b5870); font-size: .78rem; }\n.review-chip i { color: var(--ca-primary, #0e2e80); }\n.review-chip span { overflow-wrap: anywhere; }\n.review-empty { margin: 0; color: var(--ca-text-muted, #8c96a8); font-size: .82rem; }\n.submit-alert { margin-top: 1rem; }\n.step-footer { margin-top: 1.6rem; padding-top: 1rem; border-top: 1px solid var(--ca-border-light, #e9edf3); }\n.step-footer .btn { display: inline-flex; align-items: center; justify-content: center; gap: .5rem; min-height: 2.55rem; padding: .6rem 1rem; border-radius: var(--ca-radius-md, 8px); font-size: .83rem; font-weight: 650; }\n.step-footer .btn-primary { border-color: var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); }\n.step-footer .btn-primary:hover:not(:disabled) { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); }\n.step-footer .btn-outline-secondary { border-color: var(--ca-border, #dfe4ec); color: var(--ca-text-secondary, #4b5870); }\n.finish-button { min-width: 11rem; }\n.button-spinner { width: 1rem; height: 1rem; border: 2px solid rgba(255,255,255,.45); border-top-color: #fff; border-radius: 50%; animation: zone-spin .7s linear infinite; }\n\n@keyframes zone-spin { to { transform: rotate(360deg); } }\n@media (max-width: 900px) {\n  .wizard-stepper { justify-content: space-between; gap: .25rem; padding-inline: .7rem; }\n  .step-item { flex-direction: column; justify-content: center; gap: .35rem; flex: 1 1 0; text-align: center; }\n  .step-label { font-size: .7rem; white-space: normal; }\n  .step-connector { width: .7rem; flex: 0 0 .7rem; }\n  .search-toolbar { grid-template-columns: minmax(0, 1fr); }\n  .clear-button { justify-self: start; }\n  .heading-actions { align-items: flex-end; flex-direction: column; }\n}\n@media (max-width: 620px) {\n  .zone-wizard-page { padding: 1rem .7rem 1.5rem; }\n  .page-header { flex-direction: column; }\n  .cancel-top { align-self: flex-end; }\n  .heading-icon { width: 2.5rem; height: 2.5rem; }\n  .panel-heading { gap: .6rem; }\n  .panel-heading-icon { display: none; }\n  .form-grid { grid-template-columns: minmax(0, 1fr); }\n  .form-field-wide { grid-column: auto; }\n  .heading-actions { width: 100%; align-items: flex-start; flex-direction: row; flex-wrap: wrap; }\n  .selection-count { padding: .4rem .5rem; font-size: .7rem; }\n  .table-footer { align-items: flex-start; flex-direction: column; }\n  .table-footer app-pagination { align-self: flex-end; }\n  .review-details { grid-template-columns: minmax(0, 1fr); }\n  .review-details .detail-wide { grid-column: auto; }\n  .step-footer { align-items: stretch; flex-wrap: wrap; }\n  .step-footer .btn { flex: 1 1 auto; }\n}\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; transition-duration: .01ms !important; scroll-behavior: auto !important; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
